import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ButtonComponent, SlashContainer } from '@zolteam/axenergie-ui-library';
import Image from 'next/image';
// Constants
import colors from '../../constants/Colors';
import strings from '../../constants/Strings';
// Images
import rightArrow from '../../public/icons/arrow-big-white.svg';
// Hooks
import useIsMobile from '../../hooks/useIsMobile';
// Images
import checkLine from '../../public/icons/check-line.svg';
// Utils
import prestationUtils from '../../utils/prestationUtils';

const BreakdownInfoCard = ({
  contactUs,
  agencyName,
  prestationType,
  equipment,
}) => {
  const [wording, setWording] = useState(null);
  const [isMobile] = useIsMobile();
  const getWording = (prestationEquipment) => {
    if (prestationEquipment.prestationType === 3) {
      return strings.prestationPageBreakdownBlock.advices;
    }

    if (prestationEquipment.prestationType === 1 && prestationEquipment.equipment === 2) {
      return strings.prestationPageBreakdownBlock.gasBoiler.SAV;
    }
    if (prestationEquipment.prestationType === 2 && prestationEquipment.equipment === 2) {
      return strings.prestationPageBreakdownBlock.gasBoiler.installation;
    }

    if (prestationEquipment.prestationType === 1 && prestationEquipment.equipment === 3) {
      return strings.prestationPageBreakdownBlock.oilBoiler.SAV;
    }
    if (prestationEquipment.prestationType === 2 && prestationEquipment.equipment === 3) {
      return strings.prestationPageBreakdownBlock.oilBoiler.installation;
    }

    if (prestationEquipment.prestationType === 1 && prestationEquipment.equipment === 4) {
      return strings.prestationPageBreakdownBlock.woodBoiler.SAV;
    }
    if (prestationEquipment.prestationType === 2 && prestationEquipment.equipment === 4) {
      return strings.prestationPageBreakdownBlock.woodBoiler.installation;
    }

    if (prestationEquipment.prestationType === 1 && prestationEquipment.equipment === 5) {
      return strings.prestationPageBreakdownBlock.pelletBoiler.SAV;
    }
    if (prestationEquipment.prestationType === 2 && prestationEquipment.equipment === 5) {
      return strings.prestationPageBreakdownBlock.pelletBoiler.installation;
    }

    if (prestationEquipment.prestationType === 1 && prestationEquipment.equipment === 6) {
      return strings.prestationPageBreakdownBlock.heatPump.SAV;
    }
    if (prestationEquipment.prestationType === 2 && prestationEquipment.equipment === 6) {
      return strings.prestationPageBreakdownBlock.heatPump.installation;
    }

    if (prestationEquipment.prestationType === 1 && prestationEquipment.equipment === 7) {
      return strings.prestationPageBreakdownBlock.airConditioner.SAV;
    }
    if (prestationEquipment.prestationType === 2 && prestationEquipment.equipment === 7) {
      return strings.prestationPageBreakdownBlock.airConditioner.installation;
    }

    if (prestationEquipment.prestationType === 1 && prestationEquipment.equipment === 8) {
      return strings.prestationPageBreakdownBlock.hotWater.SAV;
    }
    if (prestationEquipment.prestationType === 2 && prestationEquipment.equipment === 8) {
      return strings.prestationPageBreakdownBlock.hotWater.installation;
    }

    if (prestationEquipment.prestationType === 1 && prestationEquipment.equipment === 9) {
      return strings.prestationPageBreakdownBlock.waterSoftener.SAV;
    }
    if (prestationEquipment.prestationType === 2 && prestationEquipment.equipment === 9) {
      return strings.prestationPageBreakdownBlock.waterSoftener.installation;
    }
    return null;
  };

  useEffect(() => {
    setWording(getWording({
      prestationType, equipment,
    }));
  }, [prestationType, equipment]);

  return wording && wording?.title ? (
    <div
      className="d-flex f-column align-start radius-5 white-background"
      style={{
        border: '1px solid #EDEEF1',
        width: isMobile ? '100%' : 400,
        minWidth: isMobile ? 0 : 400,
        maxWidth: 400,
      }}
    >
      <div
        className="d-flex full-width f-column align-center f-wrap top-radius grey-300-background"
        style={{ paddingBottom: 20, marginBottom: -20 }}
      >
        <div className="ph-3">
          <p className="h2 bold white-text text-align-center uppercase m-0 mt-4">{wording?.title}</p>
          <p className="h5 normal-weight white-text text-align-center mv-2">
            {prestationUtils.replaceAdherentName(wording.subtitle, agencyName)}
          </p>
        </div>
      </div>
      <SlashContainer
        width="100%"
        backgroundColor={colors.white}
        offset={10}
        position="top"
      >
        <div className="p-1" />
      </SlashContainer>
      <div
        className="d-flex f-column justify-between radius-5 ph-3 pt-3 full-width"
      >
        {
          wording.argumentation?.map((item) => (
            <div
              key={item}
              className="d-flex f-row align-center mv-1"
            >
              <div
                className="relative agency-card-check-icon mr-3"
              >
                <Image
                  src={checkLine}
                  alt="check"
                  layout="fill"
                />
              </div>
              <span className="grey-600-text small-line-height">{item}</span>
            </div>
          ))
        }
        <span className="grey-400-text medium-text normal-weight pv-3 ph-4">{wording.description}</span>
        <div className="d-flex f-column align-center mb-4">
          <ButtonComponent onClick={contactUs}>
            <div className="d-flex justify-center align-center large-button mh-4 mv-1">
              <span className="mr-3 medium-weight">
                {strings.saveTheDate}
              </span>
              <Image alt="" src={rightArrow} height={30} width={30} />
            </div>
          </ButtonComponent>
        </div>
      </div>
    </div>
  ) : null;
};

BreakdownInfoCard.propTypes = {
  prestationType: PropTypes.number.isRequired,
  equipment: PropTypes.number.isRequired,
  contactUs: PropTypes.func.isRequired,
  agencyName: PropTypes.string,
};
BreakdownInfoCard.defaultProps = {
  agencyName: '',
};

export default BreakdownInfoCard;
